import { useNavigate } from 'react-router-dom'

import { useSessionOrderEventCleanup } from 'store/trips/use-session-order-event-cleanup'

import { CreateTripProvider } from './create-trip-context'
import CreateTripContent from './create-trip-content'

const CreateTripPage = () => {
  const navigate = useNavigate()
  const { cancelTripCreation } = useSessionOrderEventCleanup()

  const handleExit = async () => {
    await cancelTripCreation()
    navigate('..')
  }

  return (
    <CreateTripProvider onExit={handleExit}>
      <CreateTripContent />
    </CreateTripProvider>
  )
}

export default CreateTripPage
